export const formatPrice = price => (
    price ? price.toLocaleString("it-IT", { style: "currency", currency: "EUR"}) : "0 €")